import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatDividerModule } from '@angular/material/divider';
import { OrderCardInfoTicketComponent } from './order-card-info-ticket.component';



@NgModule({
  declarations: [
    OrderCardInfoTicketComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    MatDividerModule
  ],
  exports: [
    OrderCardInfoTicketComponent
  ]
})
export class OrderCardInfoTicketModule { }
